import * as yup from 'yup'

type OptionType = {
    value: 'SemanticSearchSynapse' | 'SearchSynapse' | 'StructuredSearchSynapse'
    label: 'SemanticSearchSynapse' | 'SearchSynapse' | 'StructuredSearchSynapse'
}

export const options: OptionType[] = [
    { value: 'SemanticSearchSynapse', label: 'SemanticSearchSynapse' },
    { value: 'SearchSynapse', label: 'SearchSynapse' },
    { value: 'StructuredSearchSynapse', label: 'StructuredSearchSynapse' },
]

export const OpenKaitoSubnetSchema = yup.object({
    axonId: yup.number().positive(),
    size: yup.number().positive(),
    timeout: yup.number().positive(),
})

export const structuredSynapseSchema = yup.object({
    later_than_timestamp: yup.number().positive(),
})

export const errorMessages: { [index: string]: string } = {
    axonId: 'axon_id must be a positive number.',
    later_than_timestamp: 'later_than_timestamp must be a positive number.',
    size: 'size must be a positive number.',
    timeout: 'timeout must be a positive number.',
}
